import { createApp } from "vue";
import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client/core";
import { DefaultApolloClient, provideApolloClient } from "@vue/apollo-composable";
import { setContext } from "@apollo/client/link/context";

import Form from "~/vue/Form.vue";

// Main app
const form = async () => {
	const app = createApp(Form);

	const httpLink = createHttpLink({
		uri: import.meta.env.VITE_GQL_URL ?? `${window.location.origin}/api`,
	});

	const authLink = setContext((_, { headers }) => {
		return {
			headers: {
				...headers,
				authorization: `Bearer ${import.meta.env.VITE_GQL_TOKEN ?? ""}`,
			},
		};
	});

	// Create the apollo client
	const apolloProvider = new ApolloClient({
		link: authLink.concat(httpLink),
		cache: new InMemoryCache(),
	});

	provideApolloClient(apolloProvider);
	app.provide(DefaultApolloClient, apolloProvider);

	return app.mount("#form");
};

// Execute async function
form().then(() => {
	console.log();
});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
	import.meta.hot.accept(() => {
		console.log("HMR active");
	});
}
